/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Workplace Experience-teamet vårt vil nå behandle gaveforespørselen. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Kudos er opprettet',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Vi kan ikke opprette kudos eller sende gaven. Prøv å opprette en separat støtteforespørsel på <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Det oppstod en feil',
  'team-central.give-kudos.button': 'Gi kudos',
  'team-central.give-kudos.close-button.label': 'Lukk skuff',
  'team-central.give-kudos.confirm-close.title': 'Bekreft at du vil lukke',
  'team-central.give-kudos.created.description.flag': 'Kudos er sendt. <a>Vis kudos</a>',
  'team-central.give-kudos.created.title.flag': 'Kudos er opprettet',
  'team-central.give-kudos.creation.failed.description.flag': 'Vi kan ikke opprette kudos.',
  'team-central.give-kudos.creation.failed.title.flag': 'Det oppstod en feil',
  'team-central.give-kudos.error-icon.label': 'Feil',
  'team-central.give-kudos.success-icon.label': 'Vellykket',
  'team-central.give-kudos.unsaved.warning': 'Endringene dine lagres ikke.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Avbryt',
  'team-central.give-kudos.unsaved.warning.close': 'Lukk'
};